export const FURUI_GET_FRUI_BASEDATA_LIST_BEGIN = 'FURUI_GET_FRUI_BASEDATA_LIST_BEGIN';
export const FURUI_GET_FRUI_BASEDATA_LIST_SUCCESS = 'FURUI_GET_FRUI_BASEDATA_LIST_SUCCESS';
export const FURUI_GET_FRUI_BASEDATA_LIST_FAILURE = 'FURUI_GET_FRUI_BASEDATA_LIST_FAILURE';
export const FURUI_GET_FRUI_BASEDATA_LIST_DISMISS_ERROR = 'FURUI_GET_FRUI_BASEDATA_LIST_DISMISS_ERROR';
export const FURUI_SUBMIT_FRUI_BASEDATA_BEGIN = 'FURUI_SUBMIT_FRUI_BASEDATA_BEGIN';
export const FURUI_SUBMIT_FRUI_BASEDATA_SUCCESS = 'FURUI_SUBMIT_FRUI_BASEDATA_SUCCESS';
export const FURUI_SUBMIT_FRUI_BASEDATA_FAILURE = 'FURUI_SUBMIT_FRUI_BASEDATA_FAILURE';
export const FURUI_SUBMIT_FRUI_BASEDATA_DISMISS_ERROR = 'FURUI_SUBMIT_FRUI_BASEDATA_DISMISS_ERROR';
export const FURUI_DELETE_FRUI_BASEDATA_BEGIN = 'FURUI_DELETE_FRUI_BASEDATA_BEGIN';
export const FURUI_DELETE_FRUI_BASEDATA_SUCCESS = 'FURUI_DELETE_FRUI_BASEDATA_SUCCESS';
export const FURUI_DELETE_FRUI_BASEDATA_FAILURE = 'FURUI_DELETE_FRUI_BASEDATA_FAILURE';
export const FURUI_DELETE_FRUI_BASEDATA_DISMISS_ERROR = 'FURUI_DELETE_FRUI_BASEDATA_DISMISS_ERROR';
export const FURUI_FRUI_BASEDATA_MODAL_CHANGE = 'FURUI_FRUI_BASEDATA_MODAL_CHANGE';
export const FURUI_CHOOSE_CURRENT_FRUI_BASEDATA = 'FURUI_CHOOSE_CURRENT_FRUI_BASEDATA';
export const FURUI_GET_FRUI_QPGOODS_LIST_BEGIN = 'FURUI_GET_FRUI_QPGOODS_LIST_BEGIN';
export const FURUI_GET_FRUI_QPGOODS_LIST_SUCCESS = 'FURUI_GET_FRUI_QPGOODS_LIST_SUCCESS';
export const FURUI_GET_FRUI_QPGOODS_LIST_FAILURE = 'FURUI_GET_FRUI_QPGOODS_LIST_FAILURE';
export const FURUI_GET_FRUI_QPGOODS_LIST_DISMISS_ERROR = 'FURUI_GET_FRUI_QPGOODS_LIST_DISMISS_ERROR';
export const FURUI_SUBMIT_FRUI_QPGOODS_BEGIN = 'FURUI_SUBMIT_FRUI_QPGOODS_BEGIN';
export const FURUI_SUBMIT_FRUI_QPGOODS_SUCCESS = 'FURUI_SUBMIT_FRUI_QPGOODS_SUCCESS';
export const FURUI_SUBMIT_FRUI_QPGOODS_FAILURE = 'FURUI_SUBMIT_FRUI_QPGOODS_FAILURE';
export const FURUI_SUBMIT_FRUI_QPGOODS_DISMISS_ERROR = 'FURUI_SUBMIT_FRUI_QPGOODS_DISMISS_ERROR';
export const FURUI_DELETE_FRUI_QPGOODS_BEGIN = 'FURUI_DELETE_FRUI_QPGOODS_BEGIN';
export const FURUI_DELETE_FRUI_QPGOODS_SUCCESS = 'FURUI_DELETE_FRUI_QPGOODS_SUCCESS';
export const FURUI_DELETE_FRUI_QPGOODS_FAILURE = 'FURUI_DELETE_FRUI_QPGOODS_FAILURE';
export const FURUI_DELETE_FRUI_QPGOODS_DISMISS_ERROR = 'FURUI_DELETE_FRUI_QPGOODS_DISMISS_ERROR';
export const FURUI_FRUI_QPGOODS_MODAL_CHANGE = 'FURUI_FRUI_QPGOODS_MODAL_CHANGE';
export const FURUI_CHOOSE_CURRENT_FRUI_QPGOODS = 'FURUI_CHOOSE_CURRENT_FRUI_QPGOODS';
export const FURUI_GET_FRUI_PLAN_LIST_BEGIN = 'FURUI_GET_FRUI_PLAN_LIST_BEGIN';
export const FURUI_GET_FRUI_PLAN_LIST_SUCCESS = 'FURUI_GET_FRUI_PLAN_LIST_SUCCESS';
export const FURUI_GET_FRUI_PLAN_LIST_FAILURE = 'FURUI_GET_FRUI_PLAN_LIST_FAILURE';
export const FURUI_GET_FRUI_PLAN_LIST_DISMISS_ERROR = 'FURUI_GET_FRUI_PLAN_LIST_DISMISS_ERROR';
export const FURUI_SUBMIT_FRUI_PLAN_BEGIN = 'FURUI_SUBMIT_FRUI_PLAN_BEGIN';
export const FURUI_SUBMIT_FRUI_PLAN_SUCCESS = 'FURUI_SUBMIT_FRUI_PLAN_SUCCESS';
export const FURUI_SUBMIT_FRUI_PLAN_FAILURE = 'FURUI_SUBMIT_FRUI_PLAN_FAILURE';
export const FURUI_SUBMIT_FRUI_PLAN_DISMISS_ERROR = 'FURUI_SUBMIT_FRUI_PLAN_DISMISS_ERROR';
export const FURUI_DELETE_FRUI_PLAN_BEGIN = 'FURUI_DELETE_FRUI_PLAN_BEGIN';
export const FURUI_DELETE_FRUI_PLAN_SUCCESS = 'FURUI_DELETE_FRUI_PLAN_SUCCESS';
export const FURUI_DELETE_FRUI_PLAN_FAILURE = 'FURUI_DELETE_FRUI_PLAN_FAILURE';
export const FURUI_DELETE_FRUI_PLAN_DISMISS_ERROR = 'FURUI_DELETE_FRUI_PLAN_DISMISS_ERROR';
export const FURUI_FRUI_PLAN_MODAL_CHANGE = 'FURUI_FRUI_PLAN_MODAL_CHANGE';
export const FURUI_CHOOSE_CURRENT_FRUI_PLAN = 'FURUI_CHOOSE_CURRENT_FRUI_PLAN';






// WEBPACK FOOTER //
// ./src/features/furui/redux/constants.js